module.exports = __webpack_public_path__ + "static/media/slide01_feature.bd175cdf.png";